import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useProfileDropdown } from "@hooks/useProfileDropdown";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import ChangePasswordModal from "@features/ChangePassword/ChangePasswordModal";
import { useTranslation } from "react-i18next";
import ProfileModal from "@features/Profile/components";
import { UserModal } from "@components/common/Modal/UserModal";
import { LogoutConfirmationModal } from "@components/Auth";
import Button from "@components/common/Button/Button";

const ProfileDropdown = () => {
	const {
		showMenu,
		menuRef,
		handleToggle,
		handleLogout,
		handleLogoutConfirm,
		handleLogoutCancel,
		showLogoutModal,
		ShowProfile,
		HideProfile,
		showProfileModal,
		ShowChangePassword,
		HideChangePassword,
		showChangePasswordModal,
	} = useProfileDropdown();
	const { t } = useTranslation();

	const ExpandIcon = showMenu ? (
		<ExpandLessIcon sx={{ fontSize: 24, color: "#161616" }} />
	) : (
		<ExpandMoreIcon sx={{ fontSize: 24, color: "#161616" }} />
	);

	return (
		<div className="relative">
			<Button onClick={handleToggle} variant="icon">
				{ExpandIcon}
			</Button>
			{showMenu && (
				<div
					ref={menuRef}
					className="profile-dropdown-menu absolute right-0 mt-3 w-56 rounded-xl border border-gray-200 bg-white shadow-xl z-[100]"
					role="menu"
					aria-label="Profile menu">
					<div
						className="profile-dropdown-item cursor-pointer"
						role="menuitem"
						onClick={ShowProfile}>
						<PersonOutlineOutlinedIcon color="info" sx={{ fontSize: 24 }} />
						{t("psdaCommon.profile.profileTitle")}
					</div>
					<div
						className="profile-dropdown-item cursor-pointer"
						role="menuitem"
						onClick={ShowChangePassword}>
						<KeyOutlinedIcon color="info" sx={{ fontSize: 24 }} />
						{t("psdaCommon.profile.changePassword.menuLabel")}
					</div>
					<div className="profile-dropdown-divider" role="separator" aria-orientation="horizontal" />
					<div
						className="profile-dropdown-item profile-dropdown-item--logout cursor-pointer"
						onClick={handleLogout}
						role="menuitem"
						tabIndex={0}
						onKeyDown={e => {
							if (e.key === "Enter" || e.key === " ") {
								e.preventDefault();
								handleLogout();
							}
						}}>
						<LogoutOutlinedIcon color="error" sx={{ fontSize: 24 }} />
						{t("psdaCommon.common.buttons.logout")}
					</div>
				</div>
			)}
			{showProfileModal && (
				<UserModal
					heigth={100}
					width={35}
					show={showProfileModal}
					onClose={HideProfile}
					children={<ProfileModal HideProfile={HideProfile} />}
				/>
			)}
			<ChangePasswordModal isOpen={showChangePasswordModal} onClose={HideChangePassword} />
			<LogoutConfirmationModal show={showLogoutModal} onConfirm={handleLogoutConfirm} onCancel={handleLogoutCancel} />
		</div>
	);
};
export default ProfileDropdown;
